import { useCallback } from 'react';

/**
 * Custom hook to play an error beep sound
 * @returns {Function} playErrorSound - Function to play the error sound
 */
export const useErrorSound = () => {
    const playErrorSound = useCallback(() => {
        try {
            const audioContext = new (window.AudioContext || window.webkitAudioContext)();
            const oscillator = audioContext.createOscillator();
            const gainNode = audioContext.createGain();

            oscillator.connect(gainNode);
            gainNode.connect(audioContext.destination);

            oscillator.frequency.value = 400; // Error beep frequency
            oscillator.type = 'sine';

            gainNode.gain.setValueAtTime(1, audioContext.currentTime);
            gainNode.gain.exponentialRampToValueAtTime(0.08, audioContext.currentTime + 0.3);

            oscillator.start(audioContext.currentTime);
            oscillator.stop(audioContext.currentTime + 0.3);
        } catch (error) {
            console.warn('Could not play error sound:', error);
        }
    }, []);

    return playErrorSound;
};
